/* eslint-disable no-param-reassign */
/* eslint-disable no-plusplus */
import * as THREE      from 'three';
import SceneVisualBase from './SceneVisualObjectBase'

const vShader = `
attribute float size; 
attribute vec3 customColor; 
varying vec3 vColor; 
void main() { 
  vColor =  customColor; 
  vec4 mvPosition = modelViewMatrix * vec4( position, 1.0 ); 
  gl_PointSize = size ; 
  gl_Position = projectionMatrix * mvPosition;
}`;

const fShader = `
uniform vec3 color; 
uniform sampler2D pointTexture;
varying vec3 vColor; 
void main() { 
gl_FragColor = vec4( color * vColor, 1.0 );
gl_FragColor = gl_FragColor * texture2D( pointTexture, gl_PointCoord ); 
if ( gl_FragColor.a < ALPHATEST ) discard; } `;

let particles;

export default class Grid extends SceneVisualBase {
  /**
   *
   * @param camera
   * @param {number} size
   * @param {number} divisions
   */
  constructor(camera, size, divisions) {
    super(camera)
    this.size = size;
    this.divisions = divisions;
    this.vertices = []

    console.log('size', this.size)
    this.add( new THREE.GridHelper(this.size, this.divisions) )

    this.colorHighlight = new THREE.Color('#ff0000')
    this.colorDefault = new THREE.Color('#ffffff')

    this.object = new THREE.Group();
    this.object.name = 'gridParticles'
    this.draw2DGridPoint(this.size, this.divisions);
    // return this.draw2DGridPoint(this.size, this.divisions, this.sphereGeometry, this.material, this.grid2DGroup);
  }

  draw2DGridPoint(size, divisions) {
    const step = size / divisions;
    const halfSize = size / 2;

    this.vertices.length = 0
    for (let i = 0, x = -halfSize; i <= divisions; i++, x += step) {
      for (let i = 0, z = -halfSize; i <= divisions; i++, z += step) {
        this.vertices.push(new THREE.Vector3(x, 0, z));
      }
    }
    const positions = new Float32Array(this.vertices.length * 3);
    const colors = new Float32Array(this.vertices.length * 3);
    const sizes = new Float32Array(this.vertices.length);
    let vertex;
    const color = this.colorDefault.clone();
    for (let i = 0, l = this.vertices.length; i < l; i++) {
      vertex = this.vertices[i];
      vertex.toArray(positions, i * 3);
      color.toArray(colors, i * 3);
      sizes[i] = 10;
    }
    const geometry = new THREE.BufferGeometry();
    geometry.addAttribute('position', new THREE.BufferAttribute(positions, 3));
    geometry.addAttribute('customColor', new THREE.BufferAttribute(colors, 3));
    geometry.addAttribute('size', new THREE.BufferAttribute(sizes, 1));
    //
    const material = new THREE.ShaderMaterial({
      uniforms: {
        color: {
          value: new THREE.Color(0xf2f5eb),
        },
        pointTexture: {
          value: new THREE.TextureLoader().load('./images/disc.png'),
        },
      },
      vertexShader: vShader,
      fragmentShader: fShader,
      alphaTest: 0.9,
    });
    //
    particles = new THREE.Points(geometry, material);


    this.object = particles
    this.add(this.object)
    // return [particles, new THREE.GridHelper(this.size, this.divisions), vertices, geometry];
  }

  setPointHighlight(index, highlight) {
    let color = highlight? this.colorHighlight : this.colorDefault

    this.object.geometry.attributes.customColor.array[index * 3] = color.r;
    this.object.geometry.attributes.customColor.array[index * 3 + 1] = color.g;
    this.object.geometry.attributes.customColor.array[index * 3 + 2] = color.b;
    this.object.geometry.attributes.customColor.needsUpdate = true;
  }
  showPoints(){
    return this.object.visible = true;
    }
  hidePoints(){
    return this.object.visible = false
  }

  getPointPosition(index) {
    return this.vertices[index]
  }

  raycastPoint(mouse) {
    return this.raycaster.getObjects(mouse, this.object)
  }
}
